import { render } from "./HomeOnePage.vue?vue&type=template&id=47577498&ts=true"
import script from "./HomeOnePage.vue?vue&type=script&lang=ts"
export * from "./HomeOnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__